import { render } from "./StockInDetailView.vue?vue&type=template&id=c2a9f1b2&scoped=true"
import script from "./StockInDetailView.vue?vue&type=script&lang=js"
export * from "./StockInDetailView.vue?vue&type=script&lang=js"

import "./StockInDetailView.vue?vue&type=style&index=0&id=c2a9f1b2&scoped=true&lang=css"

import exportComponent from "/Users/kokleng/Documents/old_macbook/document/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a9f1b2"]])

export default __exports__